import { defineField, defineType } from 'sanity'
import { internalPages } from '../../structure/deskStructure'

export default defineType({
  title: 'Special event hero',
  name: 'specialEventHero',
  type: 'object',
  fields: [
    defineField({
      title: 'URL (i)',
      name: 'url',
      description: 'Search for internal page.',
      type: 'reference',
      to: internalPages.map((page) => ({ type: page })),
      options: {
        disableNew: true,
      },
    }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
    }),
  ],
  preview: {
    select: {
      title: 'hero.name',
    },
    prepare({ title }) {
      return {
        title: title || 'Special Event Hero',
        subtitle: 'Special Event Hero',
      }
    },
  },
})
